import Loading from 'components/loading';
import React from 'react';
import './button.scss';

export type IbuttonProps = {
  label?: string;
  containerWidth?: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
};

const Button: React.FC<IbuttonProps> = (props: IbuttonProps) => {
  const { label = '', onClick = () => { }, className = '', disabled = false, containerWidth = 'auto', isLoading = false } = props;

  return (
    <div data-testid="button" style={{ width: containerWidth }}>
      <button
        type="button"
        className={`btn-next ${className}`}
        onClick={onClick}
        disabled={disabled}
      >
        {!isLoading ? label : <Loading isSmall />}
      </button>
    </div>
  );
};

export default Button;
